import { LegalDocumentPage } from '../Legal/LegalDocumentPage'
import { cookiesContent } from '../Legal/cookiesContent'

export const Cookies = () => <LegalDocumentPage content={cookiesContent} />
